import React from 'react';
import type { FC } from 'react';
import { Backdrop, Box, Portal, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import LogoWhite from './LogoWhite';

const LoadingOperationUsesStyles = makeStyles({
    '@keyframes testAnimation': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    root: {
        animation: '$testAnimation 2s infinite',
    },
});

interface EnergoLoadingOperationProps {
    visible: boolean;
}

const EnergoLoadingOperation: FC<EnergoLoadingOperationProps> = ({ visible }) => {
    const classes = LoadingOperationUsesStyles();

    return (
        <Portal>
            <Backdrop
                open={visible}
                sx={{
                    color: '#fff',
                    position: 'fixed',
                    inset: 0,
                    zIndex: 999999999,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                }}
            >
                <Stack
                    direction="column"
                    spacing={2}
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box className={classes.root}>
                        <LogoWhite />
                    </Box>
                </Stack>
            </Backdrop>
        </Portal>
    );
};

export default EnergoLoadingOperation;
